import React from 'react';

import styles from './Input.module.scss';

const Input = ({name, label, value = '', onChange = () => {}, type = "text", required = false}) => {
    return (
        <div className={`${styles.inputData} ${value !== '' && styles.filled}`}>
            <input type={type} name={name} value={value} onChange={onChange} required={required} />
            <div className={styles.underline}></div>
            <label htmlFor={name}>{label}</label>
        </div>
    )
};

export default Input;